import * as React from 'react';

import {Popover} from 'shells/popover/popover';

import styles from './file-list.module.css';

type Props = {
    anchor: any;
    files: {
        filename: string;
        href: string;
    }[];
    onClose: () => any;
};

export class FileList extends React.PureComponent<Props> {
    render() {
        return (
            <Popover
                anchor={this.props.anchor}
                location='bottom-left'
                // @ts-expect-error
                onClose={this.props.onClose}
                onBlur={this.props.onClose}
            >
                <ul className={styles.container}>
                    {this.props.files.map((file) => (
                        <li key={file.href} className={styles['option-container']}>
                            <a onClick={this.props.onClose} href={file.href}>
                                {file.filename}
                            </a>
                        </li>
                    ))}
                </ul>
            </Popover>
        );
    }
}
